/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/
/* Style imports */
import './styles.css';

/* Library imports */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from "axios";
import classNames from 'classnames'
/* Component imports */
import Gutter from "../Gutter/Gutter";

/*** End Imports ***/

class LoginFooter extends Component{
    constructor(props){
        super(props);
        this.state = {

        };
    }
    componentWillMount(){

    }

    componentDidMount() {

    }

    onClickChangeUserLoginModal = () => {
     this.props.onClickChangeUserLoginModal();
    };




    render() {
        return(
            <div className="bottom-layer">

                <Gutter height={this.props.gutterHeight ? this.props.gutterHeight : 67}/>

                <div className="dashed-border">
                </div>

                <Gutter height={this.props.middleGutterHeight ? this.props.middleGutterHeight : 27}/>

                <div className="bl-content">{this.props.bottomLayerContent}</div>
                <div 
                    className = "bl-action-btn" 
                    onClick = {this.onClickChangeUserLoginModal}
                >
                    {this.props.bottomLayerActionContent}
                    <div className="blab-underline"></div>
                </div>
            </div>
        );
    }
}

LoginFooter.propTypes = {

};

LoginFooter.defaultProps ={

};

export default LoginFooter;


// WEBPACK FOOTER //
// ./src/components/core/LoginFooter/LoginFooter.js


// WEBPACK FOOTER //
// ./src/components/core/LoginFooter/LoginFooter.js